var _templateObject, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _taggedTemplateLiteral(e, t) { return t || (t = e.slice(0)), Object.freeze(Object.defineProperties(e, { raw: { value: Object.freeze(t) } })); }
import styled from '@emotion/styled';
import MUISvgIcon, { svgIconClasses } from '@mui/material/SvgIcon';
import * as React from "react";
var SvgIcon = styled(MUISvgIcon)(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  &.", " {\n    width: ", ";\n    height: ", ";\n    color: ", ";\n    stroke-width: 1px;\n    vector-effect: non-scaling-stroke;\n  }\n"])), svgIconClasses.root, function (_ref) {
  var size = _ref.size,
    theme = _ref.theme;
  return size && theme.size[size];
}, function (_ref2) {
  var size = _ref2.size,
    theme = _ref2.theme;
  return size && theme.size[size];
}, function (_ref3) {
  var color = _ref3.color,
    theme = _ref3.theme;
  return color && theme.color[color];
});
var SvgLightDisplayMode = function SvgLightDisplayMode(props) {
  return /*#__PURE__*/React.createElement(SvgIcon, props, /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 17 16"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M16.5 8A8 8 0 1 1 .499 8 8 8 0 0 1 16.5 8M9.3 3.2a.8.8 0 0 0-1.6 0v.4a.8.8 0 0 0 1.6 0zm0 9.2a.8.8 0 1 0-1.6 0v.4a.8.8 0 1 0 1.6 0zM14.1 8a.8.8 0 0 1-.8.8h-.4a.8.8 0 1 1 0-1.6h.4a.8.8 0 0 1 .8.8m-10 .8a.8.8 0 0 0 0-1.6h-.4a.8.8 0 0 0 0 1.6zm.44-4.76a.8.8 0 0 1 1.131 0l.283.283a.8.8 0 0 1-1.13 1.131l-.284-.283a.8.8 0 0 1 0-1.131m7.637 6.506a.8.8 0 1 0-1.131 1.13l.283.284a.8.8 0 0 0 1.131-1.131zm.283-6.506a.8.8 0 0 1 0 1.131l-.283.283a.8.8 0 0 1-1.131-1.13l.283-.284a.8.8 0 0 1 1.131 0m-6.506 7.637a.8.8 0 1 0-1.13-1.131l-.284.283a.8.8 0 0 0 1.131 1.131zM10.9 8a2.4 2.4 0 1 1-4.8 0 2.4 2.4 0 0 1 4.8 0",
    clipRule: "evenodd",
    vectorEffect: "non-scaling-stroke"
  }))));
};
export default SvgLightDisplayMode;